import { authApiCall } from "../../auth";

export const updatePoints = (to_user_id, amount, requestId, requestStatus) => {
  return authApiCall({
    url: `/points/update-points/${to_user_id}/`,
    method: 'put',
    data: {amount, requestId, requestStatus}
  });
};
